import { Button, Colors, IcGrid, IcList, InputSearch } from 'basic-ui-lib';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ViewMode } from 'modules/media/services/hooks/useViewMode';
import useDebounce from 'hooks/useDebounce';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';

interface HeaderSearchProps {
  viewMode?: ViewMode;
  onChangeViewMode?: (mode: ViewMode) => void;
//   path: BreadcrumbPath[];
//   onBack: () => void;
  currentPath: string;
}

const HeaderSearch = ({ viewMode, onChangeViewMode, currentPath }: HeaderSearchProps) => {
  const [, mutate] = useGetManageLibrary(true);

  const onSearchDebounce = useCallback((value: string) => {
    mutate(currentPath, value);
  }, []);

   const { text: searchText, setText: setSearchText } = useDebounce({
    timeDebounce: 600,
    onDebounce: onSearchDebounce,
  });
  
  return (
    <Container>
      <InputSearch placeholder='Search media...' value={searchText} onChange={(value) => setSearchText(value)} />
      <Button
        {...(viewMode === 'list' ? { type_new: true } : { type_ghost: true })}
        lg
        className='custom-button'
        onClick={() => onChangeViewMode && onChangeViewMode('list')}
      >
        <IcList width={24} height={24} fill={viewMode === 'list' ? Colors.primary[5] : undefined} />
      </Button>
      <Button
        {...(viewMode === 'grid' ? { type_new: true } : { type_ghost: true })}
        lg
        className='custom-button'
        onClick={() => onChangeViewMode && onChangeViewMode('grid')}
      >
        <IcGrid width={24} height={24} fill={viewMode === 'grid' ? Colors.primary[5] : undefined} />
      </Button>
    </Container>
  );
};

export default HeaderSearch;

const Container = styled.div`
  display: flex;
  gap: 8px;

  .custom-text {
    white-space: nowrap;
  }

  .custom-button {
    padding: 0 12px;
    height: 48px;

    .custom-text {
      line-height: 0;
    }
  }
`;
